// University of Arkansas undergraduate majors (#2652). Read on 2026-10-01 from
// the official Catalog of Studies, 2026-27 Edition, Programs of Study page,
// "Programs by College or School" tab (catalog.uark.edu), which lists every
// major under the college or school that offers it. The list gives no degree
// abbreviations, so `degree` is null except for Fulbright's "Economics
// (Bachelor of Arts)", written here as Economics, B.A. The School of Human
// Environmental Sciences (part of Bumpers College) and Fulbright's second
// (dependent) majors are their own groups, as the catalog sets them apart.
// Data Science is listed under Fulbright, Walton and Engineering and appears
// in each. Undeclared status, minors and certificates are left out. The KB's
// majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-arkansas",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in the University of Arkansas Catalog of Studies 2026-27, grouped by the college or school that offers it, as the catalog lists them. The list does not name the degree for each major, so none is shown except where it does. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Dale Bumpers College of Agricultural, Food and Life Sciences",
            "source": {
                "label": "University of Arkansas Catalog of Studies 2026-27, Programs of Study by College or School",
                "url": "https://catalog.uark.edu/undergraduatecatalog/fieldsofstudy/#fieldsbycollegeorschooltext"
            },
            "majors": [
                {
                    "name": "Agricultural Business",
                    "degree": null
                },
                {
                    "name": "Agricultural Education, Communication and Technology",
                    "degree": null
                },
                {
                    "name": "Animal Science",
                    "degree": null
                },
                {
                    "name": "Crop Science",
                    "degree": null
                },
                {
                    "name": "Environmental, Soil, and Water Science",
                    "degree": null
                },
                {
                    "name": "Food Science",
                    "degree": null
                },
                {
                    "name": "Horticulture, Landscape and Turf Sciences",
                    "degree": null
                },
                {
                    "name": "Poultry Science",
                    "degree": null
                }
            ]
        },
        {
            "name": "Dale Bumpers College: School of Human Environmental Sciences",
            "source": {
                "label": "University of Arkansas Catalog of Studies 2026-27, Programs of Study by College or School",
                "url": "https://catalog.uark.edu/undergraduatecatalog/fieldsofstudy/#fieldsbycollegeorschooltext"
            },
            "majors": [
                {
                    "name": "Apparel Merchandising and Product Development",
                    "degree": null
                },
                {
                    "name": "Food, Nutrition and Health",
                    "degree": null
                },
                {
                    "name": "Hospitality Management",
                    "degree": null
                },
                {
                    "name": "Human Development and Family Sciences",
                    "degree": null
                },
                {
                    "name": "Human Nutrition and Dietetics",
                    "degree": null
                }
            ]
        },
        {
            "name": "Fay Jones School of Architecture and Design",
            "source": {
                "label": "University of Arkansas Catalog of Studies 2026-27, Programs of Study by College or School",
                "url": "https://catalog.uark.edu/undergraduatecatalog/fieldsofstudy/#fieldsbycollegeorschooltext"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": null
                },
                {
                    "name": "Architectural Studies",
                    "degree": null
                },
                {
                    "name": "Interior Architecture and Design",
                    "degree": null
                },
                {
                    "name": "Landscape Architecture",
                    "degree": null
                }
            ]
        },
        {
            "name": "Fulbright College of Arts and Sciences",
            "source": {
                "label": "University of Arkansas Catalog of Studies 2026-27, Programs of Study by College or School",
                "url": "https://catalog.uark.edu/undergraduatecatalog/fieldsofstudy/#fieldsbycollegeorschooltext"
            },
            "majors": [
                {
                    "name": "Advertising and Public Relations",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Art (Studio Art)",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Communication",
                    "degree": null
                },
                {
                    "name": "Criminology",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Earth Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Geology",
                    "degree": null
                },
                {
                    "name": "Graphic Design",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": null
                },
                {
                    "name": "International and Global Studies",
                    "degree": null
                },
                {
                    "name": "Journalism",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Social Work",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                },
                {
                    "name": "World Languages, Literatures and Cultures",
                    "degree": null
                }
            ]
        },
        {
            "name": "Fulbright College of Arts and Sciences: second (dependent) majors",
            "source": {
                "label": "University of Arkansas Catalog of Studies 2026-27, Programs of Study by College or School",
                "url": "https://catalog.uark.edu/undergraduatecatalog/fieldsofstudy/#fieldsbycollegeorschooltext"
            },
            "majors": [
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "African and African American Studies",
                    "degree": null
                },
                {
                    "name": "Latin American and Latino Studies",
                    "degree": null
                },
                {
                    "name": "Middle East Studies",
                    "degree": null
                }
            ],
            "note": "A second (or dependent) major is earned alongside a first major that can be awarded on its own."
        },
        {
            "name": "Sam M. Walton College of Business",
            "source": {
                "label": "University of Arkansas Catalog of Studies 2026-27, Programs of Study by College or School",
                "url": "https://catalog.uark.edu/undergraduatecatalog/fieldsofstudy/#fieldsbycollegeorschooltext"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Business, General",
                    "degree": null
                },
                {
                    "name": "Business, International",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Information Systems",
                    "degree": null
                },
                {
                    "name": "Innovation and Entrepreneurship",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Organizational Management and Leadership",
                    "degree": null
                },
                {
                    "name": "Retail",
                    "degree": null
                },
                {
                    "name": "Supply Chain Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Education and Health Professions",
            "source": {
                "label": "University of Arkansas Catalog of Studies 2026-27, Programs of Study by College or School",
                "url": "https://catalog.uark.edu/undergraduatecatalog/fieldsofstudy/#fieldsbycollegeorschooltext"
            },
            "majors": [
                {
                    "name": "Career and Technical Education",
                    "degree": null
                },
                {
                    "name": "Childhood Education",
                    "degree": null
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": null
                },
                {
                    "name": "Drama Education",
                    "degree": null
                },
                {
                    "name": "Early Childhood Education",
                    "degree": null
                },
                {
                    "name": "Educational Studies",
                    "degree": null
                },
                {
                    "name": "Elementary Education",
                    "degree": null
                },
                {
                    "name": "English Education",
                    "degree": null
                },
                {
                    "name": "Exercise Science",
                    "degree": null
                },
                {
                    "name": "French Education",
                    "degree": null
                },
                {
                    "name": "German Education",
                    "degree": null
                },
                {
                    "name": "Human Resource Development",
                    "degree": null
                },
                {
                    "name": "Nursing",
                    "degree": null
                },
                {
                    "name": "Public Health",
                    "degree": null
                },
                {
                    "name": "Recreation and Sport Management",
                    "degree": null
                },
                {
                    "name": "Social Studies Education",
                    "degree": null
                },
                {
                    "name": "Spanish Education",
                    "degree": null
                },
                {
                    "name": "Special Education",
                    "degree": null
                },
                {
                    "name": "Teaching K-12 Physical Education and Health",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "University of Arkansas Catalog of Studies 2026-27, Programs of Study by College or School",
                "url": "https://catalog.uark.edu/undergraduatecatalog/fieldsofstudy/#fieldsbycollegeorschooltext"
            },
            "majors": [
                {
                    "name": "Biological Engineering",
                    "degree": null
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Industrial Engineering and Operations Analytics",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
